import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Data, User } from '~/utils';
import LinkedBudgetRequestForm from '~/components/project-portfolio/linked-budget-request-edit/linked-budget-request-form/linked-budget-request-form.vue';
import { CombinedDataField } from '~/models/services/project-portfolio';

@Component({
    components: {
        LinkedBudgetRequestForm,
    }
})
export default class LinkedBudgetRequestEditComponent extends Vue {
    private userPermissions = <any>[];
    private isAccessDeniedModalActive: boolean = false;
    private data: Data = Data.Instance;

    @Prop()
    private combinedData: CombinedDataField[];

    @Prop()
    private id: string;

    async created() {
        this.userPermissions = await User.getPerm();
        if (!this.hasPermission) {
            $('#accessDeniedModal').modal('show');
            this.isAccessDeniedModalActive = true;
        }
    }

    private get hasPermission(): boolean {
        return this.userPermissions.includes('CombinedBudgetEdit');
    }

    private onClickCancel(value) {
        this.isAccessDeniedModalActive = value;
    }
}
